import React, { Fragment } from "react";
import {
  Box,
  Backdrop,
  Button,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Link,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning"; // For Low Stock
import DoNotDisturbOnIcon from "@mui/icons-material/DoNotDisturbOn"; // For No Stock
import SubdirectoryArrowLeftIcon from "@mui/icons-material/SubdirectoryArrowLeft";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { SouthAfricanRand } from "../../utils/helpers";
import { COLORS } from "../../constants";
import { AccountType, ProductAvailability } from "../../utils/constants";
import RelatedProducts from "../RelatedProducts/RelatedProducts";
import YouMightAlsoLike from "../YouMightAlsoLike/YouMightAlsoLike";
import ProductTabs from "./ProductTabs";
import MobileProductInfo from "./MobileProductInfo";

const MobileProduct = ({
  pricingData,
  accountType,
  loading,
  handleAddToCartClick,
  productPrice,
  availabilityValue,
  quantity,
  setQuantity,
  numberOfRows,
  handleApplicationFilterClick,
  applicationColumns,
  applicationMakes,
  applicationModels,
  applicationVariants,
  applicationYears,
  applicationFilters,
  setApplicationFilters,
  tabValue,
  handleTabChange,
  product,
  authError,
}) => {
  return (
    <Fragment>
      <Container sx={{ paddingTop: 3, paddingBottom: 10 }} disableGutters>
        <Box sx={{ mt: 1 }}>
          {product ? (
            <Grid
              container
              spacing={2}
              sx={{ flexDirection: { xs: "column", md: "row" } }}
            >
              <Grid item xs={12} md={8.7}>
                <MobileProductInfo
                  product={product}
                  productPrice={productPrice}
                  accountType={accountType}
                  availabilityValue={availabilityValue}
                  quantity={quantity}
                  setQuantity={setQuantity}
                  handleAddToCartClick={handleAddToCartClick}
                />

                {/* Tabs Section */}
                <ProductTabs
                  tabValue={tabValue}
                  handleTabChange={handleTabChange}
                  product={product}
                  applicationMakes={applicationMakes}
                  applicationColumns={applicationColumns}
                  numberOfRows={numberOfRows}
                  handleApplicationFilterClick={handleApplicationFilterClick}
                  applicationFilters={applicationFilters}
                  authError={authError}
                />
              </Grid>
            </Grid>
          ) : (
            <Box sx={{ textAlign: "center", marginTop: 4 }}>
              <Typography variant="h6">No product found</Typography>
            </Box>
          )}
        </Box>
      </Container>

      {availabilityValue !== ProductAvailability.No_Stock && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mt: 10,
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: COLORS.white,
            borderTop: `1px solid ${COLORS.border}`,
            boxShadow: "0 -4px 12px rgba(0,0,0,0.08)",
            px: 2,
            py: 1.5,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "2px",
              backgroundColor: COLORS.background,
              padding: "0.45em 0.25rem",
              width: "8rem",
            }}
          >
            <IconButton
              onClick={() => setQuantity(Math.max(1, quantity - 1))}
              disabled={quantity <= 1}
              sx={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                padding: 0,
                color: COLORS.gray,
              }}
            >
              <RemoveIcon fontSize="small" />
            </IconButton>
            <Typography
              sx={{
                flex: 1,
                textAlign: "center",
                padding: "0 0.5rem",
                color: COLORS.darkText,
              }}
            >
              {quantity}
            </Typography>
            <IconButton
              onClick={() => setQuantity(Math.min(99, quantity + 1))}
              disabled={quantity >= 99}
              sx={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                padding: 0,
                color: COLORS.gray,
              }}
            >
              <AddIcon fontSize="small" />
            </IconButton>
          </Box>
          <Button
            variant="contained"
            color="primary"
            size="small"
            fullWidth
            onClick={() => {
              handleAddToCartClick();
            }}
            disabled={quantity < 1}
            sx={{
              backgroundColor: COLORS.themeYellow,
              color: COLORS.darkText,
              padding: "0.5rem 0.2rem 0.5rem 0.2rem",
              borderRadius: "2px",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: COLORS.themeYellow,
                opacity: 0.9,
              },
            }}
          >
            <ShoppingCartIcon sx={{ color: COLORS.darkText, mr: 0.5 }} />
            Add to Cart
          </Button>
        </Box>
      )}
    </Fragment>
  );
};

export default MobileProduct;
